
import { MutationTree } from 'vuex';
import { GspServiceState } from './types';
import Vue from 'vue';
import gspService, { GspService, Value } from '@/shared/model/gspService';

export const mutations: MutationTree<GspServiceState> = {
  setGspServices(state, payload: Value) {
    state.gspServices.items = payload.value.map((x) => gspService.parse(x));
    state.gspServices.total = payload['@odata.count'] || 0;
    state.gspServices.isLoading = false;
  },
  setGspServicesTotal(state, payload: number) {
    state.gspServices.total = payload;
  },
  setGspServicesIsLoading(state, payload: boolean) {
    state.gspServices.isLoading = payload;
  },

  setGspServicesForContacts(state, payload: GspService[]) {
    state.gspServicesForContacts = payload;
  },
  setGspServicesForContactsIsLoading(state, payload: boolean) {
    state.gspServicesForContactsIsLoading = payload;
  },

  // Patch the cached objects in place so components holding this Vuex reference stay reactive.
  setGspModuleNameInServicesForContacts(state, payload: { id: number; name: string }) {
    // console.log('[vue2] setGspModuleNameInServicesForContacts:>> ', payload);
    const cachedServices: any = state.gspServicesForContacts;
    let services: any[] = [];
    // console.log('[vue2] cachedServices:>> ', cachedServices);
    
    // Support both the array and OData response data shapes
    if (Array.isArray(cachedServices)) {
      services = cachedServices;
    } else if (Array.isArray(cachedServices?.items)) {
      services = cachedServices.items;
    } else if (Array.isArray(cachedServices?.value)) {
      services = cachedServices.value;
    }

    services.forEach((service: any) => {
      service.modules?.forEach((module: any) => {
        if (Number(module.id) === Number(payload.id)) {
          Vue.set(module, 'name', payload.name);
        }
      });
    });
  },

  setServiceCommonText(state, payload: any) {
    const service = state.gspServices.items.find((x) => x.id == payload.id);
    if (service) {
      service.short_common_text = payload.short_common_text;
    }
  },
};
